export const metricsMap = {
  "inauthentic": 'Inauthentic',
  "state_affiliated": 'State-affiliated', 
  "disinfo_spreaders": 'Information manipulation',
  "influential": 'Influential',
  "social_media_original_posts": 'Posts',
  "social_media_reposts": 'Reposts',
  "media_articles": 'Media articles',
  "comments": 'Comments',
  "overall_comments": 'Overall comments',
  "videos": 'Videos',
  "ads": 'Ads',
  "chat_forum_messages": 'Chat messages',
  "reposts": 'Reposts',
  "likes_emoji": 'Reactions',
  "telegram": 'Telegram',
  "facebook": 'Facebook',
  "twitter": 'Twitter',
  "youtube": 'YouTube',
  "tiktok": 'TikTok',
  "vk": 'VK',
  "instagram": 'Instagram',
  "web": 'Web',
  "threads": 'Threads',
  "linkedin": 'LinkedIn',
  "ok": 'OK',
  'max': 'Max',
  'hupu': 'Hupu',
  'zhihu': 'Zhihu',
  'pincong': 'Pincong',
  'weibo': 'Weibo',
  'douyin': 'Douyin',
  'darkweb': 'Darkweb',
  'bluesky': 'Bluesky',
  'reddit': 'Reddit',
}

export const metricsTooltipMap = {
  'inauthentic': 'Actors are exhibiting inauthentic behavior, such as bots.',
  'influential': 'Actor that has more 100k followers / monthly visitors (Web).',
  'state_affiliated': 'Actors are affiliated with a specific country or countries.',
  'disinfo_spreaders': 'Actors are frequently sharing manipulative content.',
  'social_media_original_posts': '',
  'social_media_reposts': '',
  'media_articles': '',
  'comments': '',
  'overall_comments': '',
  'videos': '',
  'ads': '',
  'chat_forum_messages': '',
  'reposts': '',
  'likes_emoji': '',
  'telegram': 'Post views',
  'facebook': 'Video views',
  'twitter': 'Post views, data may be approximate',
  'youtube': 'Video views',
  'tiktok': 'Video views',
  'vk': 'Video views',
  'instagram': 'This platform doesn’t provide views',
  'web': 'This platform doesn’t provide views',
  'threads': 'This platform doesn’t provide views',
  'linkedin': 'This platform doesn’t provide views',
  'ok': 'This platform doesn’t provide views',
  'max': 'Post views',
  'hupu': 'This platform doesn’t provide views',
  'zhihu': 'This platform doesn’t provide views',
  'pincong': 'This platform doesn’t provide views',
  'weibo': 'This platform doesn’t provide views',
  'douyin': 'This platform doesn’t provide views',
  'darkweb': 'This platform doesn’t provide views',
  'bluesky': 'This platform doesn’t provide views',
  'reddit': 'This platform doesn’t provide views',
}

// Source: Intelligence Requirements Checklist - Engagement metrics
// Lookup: metricSupport[metric][platform][contentType]
// true = platform provides this metric for this content type
// false = N/A (platform doesn't provide this metric for this content type)
// null = not collected by us but available on the platform
export const metricSupport = {
  views: {
    FACEBOOK: { POST: true, COMMENT: false, AD: true, REPOST: false, VIDEO: true },
    INSTAGRAM: { POST: false, VIDEO: false },
    TWITTER: { POST: true, COMMENT: true, REPOST: true },
    TIKTOK: { COMMENT: false, VIDEO: true, REPOST: false },
    YOUTUBE: { VIDEO: true },
    TELEGRAM: { POST: true, MESSAGE: true, COMMENT: false, REPOST: true },
    WEB: { ARTICLE: false },
    LINKEDIN: { POST: false, VIDEO: false },
    THREADS: { POST: false, VIDEO: false },
    VK: { POST: true, COMMENT: false },
    OK: { POST: false },
    ZHIHU: { POST: false, COMMENT: false },
    HUPU: { POST: false, COMMENT: false },
    PINCONG: { POST: false, COMMENT: false },
    MAX: { POST: true, REPOST: true, COMMENT: false },
    WEIBO: { POST: false, COMMENT: false },
    DOUYIN: { POST: false, COMMENT: false },
    DARKWEB: { ARTICLE: false },
    BLUESKY: { POST: false, COMMENT: false },
    REDDIT: { POST: false, COMMENT: false },
  },
  reactions: {
    FACEBOOK: { POST: true, COMMENT: true, AD: false, REPOST: true, VIDEO: true },
    INSTAGRAM: { POST: true, VIDEO: true },
    TWITTER: { POST: true, COMMENT: true, REPOST: true },
    TIKTOK: { COMMENT: true, VIDEO: true, REPOST: false },
    YOUTUBE: { VIDEO: true },
    TELEGRAM: { POST: true, MESSAGE: true, COMMENT: true, REPOST: true },
    WEB: { ARTICLE: false },
    LINKEDIN: { POST: true, VIDEO: true },
    THREADS: { POST: true, VIDEO: true },
    VK: { POST: true, COMMENT: true },
    OK: { POST: false },
    ZHIHU: { POST: true, COMMENT: true },
    HUPU: { POST: true, COMMENT: true },
    PINCONG: { POST: true, COMMENT: true },
    MAX: { POST: true, REPOST: true, COMMENT: true },
    WEIBO: { POST: true, COMMENT: true },
    DOUYIN: { POST: true, COMMENT: true },
    DARKWEB: { ARTICLE: false },
    BLUESKY: { POST: true, COMMENT: true },
    REDDIT: { POST: true, COMMENT: true },
  },
  reposts: {
    FACEBOOK: { POST: true, COMMENT: false, AD: false, REPOST: true, VIDEO: true },
    INSTAGRAM: { POST: false, VIDEO: false },
    TWITTER: { POST: true, COMMENT: true, REPOST: true },
    TIKTOK: { COMMENT: false, VIDEO: true, REPOST: false },
    YOUTUBE: { VIDEO: false },
    TELEGRAM: { POST: true, MESSAGE: true, COMMENT: false, REPOST: true },
    WEB: { ARTICLE: false },
    LINKEDIN: { POST: true, VIDEO: true },
    THREADS: { POST: true, VIDEO: true },
    VK: { POST: true, COMMENT: false },
    OK: { POST: false },
    ZHIHU: { POST: false, COMMENT: false },
    HUPU: { POST: false, COMMENT: false },
    PINCONG: { POST: false, COMMENT: false },
    MAX: { POST: false, REPOST: false, COMMENT: false },
    WEIBO: { POST: true, COMMENT: true },
    DOUYIN: { POST: true, COMMENT: true },
    DARKWEB: { ARTICLE: false },
    BLUESKY: { POST: true, COMMENT: true },
    REDDIT: { POST: false, COMMENT: false },
  },
  comments: {
    FACEBOOK: { POST: true, COMMENT: true, AD: false, REPOST: true, VIDEO: true },
    INSTAGRAM: { POST: true, VIDEO: true },
    TWITTER: { POST: true, COMMENT: true, REPOST: true },
    TIKTOK: { COMMENT: true, VIDEO: true, REPOST: false },
    YOUTUBE: { VIDEO: true },
    TELEGRAM: { POST: true, MESSAGE: false, COMMENT: null, REPOST: true }, // COMMENT: null = not collected
    WEB: { ARTICLE: false },
    LINKEDIN: { POST: true, VIDEO: true },
    THREADS: { POST: true, VIDEO: true },
    VK: { POST: true, COMMENT: false },
    OK: { POST: true },
    ZHIHU: { POST: true, COMMENT: true },
    HUPU: { POST: true, COMMENT: true },
    PINCONG: { POST: true, COMMENT: true },
    MAX: { POST: true, REPOST: null, COMMENT: true }, // REPOST: null = not collected
    WEIBO: { POST: true, COMMENT: true },
    DOUYIN: { POST: true, COMMENT: true },
    DARKWEB: { ARTICLE: false },
    BLUESKY: { POST: true, COMMENT: true },
    REDDIT: { POST: true, COMMENT: true },
  },
  engagement: {
    FACEBOOK: { POST: true, COMMENT: true, AD: false, REPOST: true, VIDEO: true },
    INSTAGRAM: { POST: true, VIDEO: true },
    TWITTER: { POST: true, COMMENT: true, REPOST: true },
    TIKTOK: { COMMENT: true, VIDEO: true, REPOST: false },
    YOUTUBE: { VIDEO: true },
    TELEGRAM: { POST: true, MESSAGE: true, COMMENT: true, REPOST: true },
    WEB: { ARTICLE: false },
    LINKEDIN: { POST: true, VIDEO: true },
    THREADS: { POST: true, VIDEO: true },
    VK: { POST: true, COMMENT: true },
    OK: { POST: true },
    ZHIHU: { POST: true, COMMENT: true },
    HUPU: { POST: true, COMMENT: true },
    PINCONG: { POST: true, COMMENT: true },
    MAX: { POST: true, REPOST: true, COMMENT: true },
    WEIBO: { POST: true, COMMENT: true },
    DOUYIN: { POST: true, COMMENT: true },
    DARKWEB: { ARTICLE: false },
    BLUESKY: { POST: true, COMMENT: true },
    REDDIT: { POST: true, COMMENT: true },
  },
};